import { SingleDataValue } from '../data-display';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { useMetrics } from '../../contexts/MetricsContext';

export const DataTileLeftToMine = ({ animate }) => {
  const { formatted } = useMetrics();

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="# Left to Mine" value={formatted.leftToMine} />
    </ThemedFlex>
  );
};
